import jsPDF from "jspdf";

// Styled PDF matching the emerald slide layout.
export function generateBriefPDF(brief) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 56;
  const CW = W - M * 2;

  const BG = [9, 9, 11];
  const FG = [250, 250, 250];
  const MUTED = [161, 161, 170];
  const EMERALD = [16, 185, 129];

  const fill = (c) => doc.setFillColor(c[0], c[1], c[2]);
  const text = (c) => doc.setTextColor(c[0], c[1], c[2]);

  const slide = (kicker, titleLines, drawBody) => {
    fill(BG);
    doc.rect(0, 0, W, H, "F");
    // accent bar
    fill(EMERALD);
    doc.rect(M, M, 44, 5, "F");

    text(EMERALD);
    doc.setFont("courier", "normal");
    doc.setFontSize(11);
    doc.text(kicker.toUpperCase(), M, M + 34);

    text(FG);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);
    let y = M + 78;
    titleLines.forEach((l) => {
      doc.text(l, M, y);
      y += 34;
    });

    drawBody(y + 12);

    // footer
    text(MUTED);
    doc.setFont("courier", "normal");
    doc.setFontSize(9);
    doc.text("BrainIdeasFused", M, H - M);
    doc.text("Product Opportunity Brief", W - M, H - M, { align: "right" });
  };

  const bodyText = (str, y, color = FG, size = 15) => {
    text(color);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(size);
    const lines = doc.splitTextToSize(str, CW);
    doc.text(lines, M, y, { lineHeightFactor: 1.5 });
    return y + lines.length * size * 1.5;
  };

  const promptBlock = (prompt, yStart) => {
    let y = yStart;
    // keep near the bottom of the slide
    const boxTop = Math.max(y, H - M - 190);
    text(EMERALD);
    doc.setFont("courier", "normal");
    doc.setFontSize(9);
    doc.text("PROMPT USED", M, boxTop);
    text(MUTED);
    doc.setFont("courier", "normal");
    doc.setFontSize(8);
    const lines = doc.splitTextToSize(prompt.replace(/\s+/g, " ").trim(), CW);
    doc.text(lines.slice(0, 12), M, boxTop + 16, { lineHeightFactor: 1.45 });
  };

  // Slide 1
  slide("01 — Product Concept", ["Product Concept"], (y) => {
    bodyText(brief.product_concept.content, y);
  });

  // Slide 2
  doc.addPage();
  slide("02 — Target User", ["Target User"], (y) => {
    bodyText(brief.target_user.content, y, FG, 19);
  });

  // Slide 3
  doc.addPage();
  slide("03 — Core Value Proposition", ["Core Value", "Proposition"], (y) => {
    bodyText(brief.value_proposition.content, y, FG, 19);
  });

  // Slide 4
  doc.addPage();
  slide("04 — 3 Key Features", ["3 Key Features"], (y) => {
    let cy = y;
    brief.key_features.features.forEach((f, i) => {
      fill(EMERALD);
      doc.circle(M + 4, cy - 5, 3, "F");
      text(FG);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(15);
      const lines = doc.splitTextToSize(f, CW - 24);
      doc.text(lines, M + 20, cy, { lineHeightFactor: 1.4 });
      cy += lines.length * 15 * 1.4 + 16;
    });
  });

  // Slide 5 — Summary
  doc.addPage();
  const features = brief.key_features.features;
  const summaryText =
    `${brief.product_concept.content} ` +
    `Target user: ${brief.target_user.content} ` +
    `Value proposition: ${brief.value_proposition.content} ` +
    `Key features: ${features.join("; ")}.`;
  slide("Summary", ["BrainIdeasFused Summary"], (y) => {
    bodyText(summaryText, y, FG, 14);
  });

  doc.save("brainideasfused-brief.pdf");
}
